import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody, Input, Button } from 'reactstrap';
import AppleAppStore from 'assets/img/Download_on_the_App_Store_Badge_US-UK_RGB_blk_092917.png';
import GooglePlayStore from 'assets/img/GetItOnGooglePlay_Badge_Web_color_English.png';
import actions from '../../api/actions';

class ResetPassword extends Component {
  state = { password: '' };

  changePassword(e) {
    this.setState({ ...this.state, password: e.target.value });
  }

  handleSubmit() {
    const token = this.props.match.params.token;
    actions
      .create('password', { password: this.state.password, token })
      .then(r => {
        this.setState({ ...this.state, message: r.data.message });
      });
  }

  render() {
    const { password, message } = this.state;
    const isParentInvite =
      this.props.location.search.includes('flow=parent_invite');
    return (
      <Card className="register-panel mt-5 w-50 mx-auto">
        <CardBody>
          {!message && (
            <div>
              <h2 className="text-center mb-3">Enter your new password:</h2>
              <div className="text-center">
                <Input
                  onChange={this.changePassword.bind(this)}
                  type="password"
                  value={password}
                  className="mb-4"
                />
                <Button
                  color="success"
                  disabled={!password || message}
                  className="w-50"
                  onClick={this.handleSubmit.bind(this)}
                >
                  Reset Password
                </Button>
              </div>
            </div>
          )}
          {message && (
            <div>
              <h2 className="text-center mb-3">{message}</h2>
              {isParentInvite ? (
                <div>
                  <p className="text-center">
                    <strong>Now log in on our mobile app!</strong>
                  </p>
                  <div className="row mb-3 text-center">
                    <div className="col">
                      <a href="https://play.google.com/apps/testing/co.unyted.mobile">
                        <img
                          src={GooglePlayStore}
                          alt="Google Play Store (beta)"
                          height="40"
                        />
                      </a>
                    </div>
                    <div className="col">
                      <a href="https://apps.apple.com/us/app/unyted-learning/id1574580228">
                        <img
                          src={AppleAppStore}
                          alt="Apple App Store"
                          height="40"
                        />
                      </a>
                    </div>
                  </div>
                </div>
              ) : (
                <p>
                  <Link
                    to={{
                      pathname: '/login',
                    }}
                  >
                    Now log in
                  </Link>
                </p>
              )}
            </div>
          )}
        </CardBody>
      </Card>
    );
  }
}

export default ResetPassword;
